export const getApiBaseUrl = (): string => {
  // const isDevelopment = import.meta.env.MODE === 'development';
  
  // if (isDevelopment) {
  //   return 'http://localhost:8000';
  // }
  
  return 'https://backend.stridesalescoach.co';
};
